import { render, staticRenderFns } from "./ListImageGroups.vue?vue&type=template&id=3feaef03&scoped=true"
import script from "./ListImageGroups.vue?vue&type=script&lang=js"
export * from "./ListImageGroups.vue?vue&type=script&lang=js"
import style0 from "./ListImageGroups.vue?vue&type=style&index=0&id=3feaef03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feaef03",
  null
  
)

export default component.exports